import type { PropsWithChildren } from 'react';
import React from 'react';

export const EmptyFallback: React.FC<PropsWithChildren<{ error: any }>> = ({ error }) => {
  console.log(error);
  return <></>;
};
